if (!customElements.get('availability-in-stores')) {
    customElements.define(
        'availability-in-stores',
        class AvailabilityInStores extends HTMLElement {
            constructor() {
                super();
                this.apiEndpoint = 'https://monclubc.com';
                this.storeInventories = [];
                this.stores = [];
            }

            connectedCallback() {
                this.defaultLocation = 'Québec';
                this.location = this.defaultLocation;

                this.selectors = {
                    button: '#availability-in-stores-button',
                    modal: '#availability-in-stores-modal',
                    modalWrapper: '#availability-in-stores-modal-wrapper',
                    closeButton: '#availability-in-stores-modal-close',
                    addressInput: '#availability-in-stores-modal__address-input',
                    addressInputButton: '#availability-in-stores-modal__address-input-button'
                };

                this.button = this.querySelector(this.selectors.button);
                this.modal = this.querySelector(this.selectors.modal);
                this.modalWrapper = this.querySelector(this.selectors.modalWrapper);
                this.closeButton = this.querySelector(this.selectors.closeButton);
                this.addressInput = this.querySelector(this.selectors.addressInput);
                this.addressInputButton = this.querySelector(this.selectors.addressInputButton);

                this.currentSku = this.getAttribute('data-variant-sku');
                this.currentProductSize = this.getAttribute('data-product-size');
                this.currentProductStyle = this.getAttribute('data-product-style');
                
                this.addressInput.value = this.defaultLocation;

                if (this.addressInput) {
                    this.addressInput.addEventListener('keypress', this.onAddressKeyPress.bind(this));
                    this.addressInput.value = this.defaultLocation;
                }
                
                if (this.addressInputButton) {
                    this.addressInputButton.addEventListener('click', this.onAddressInputButtonClick.bind(this));
                }
                
                if (this.button) {
                    this.button.addEventListener('click', this.onClickButton.bind(this));
                }
                
                if (this.closeButton) {
                    this.closeButton.addEventListener('click', this.closeModal.bind(this));
                }
                
                document.addEventListener('click', this.onClickOutside.bind(this));
            }

            onClickButton(event) {
                event.stopPropagation();
                this.openModal();
            }

            async openModal() {
                this.resetModal();
                if (this.modalWrapper.parentElement !== document.body) {
                    this.originalParent = this.modalWrapper.parentElement;
                    document.body.appendChild(this.modalWrapper);
                }

                this.location = this.defaultLocation;
                this.addressInput.value = this.defaultLocation;
                
                this.currentSku = this.getAttribute('data-variant-sku');
                this.currentProductSize = this.getAttribute('data-product-size');
                this.currentProductStyle = this.getAttribute('data-product-style');

                document.body.classList.add('availability-in-stores-modal-open');
                this.modalWrapper.classList.add('active');

                this.modal.classList.add('loading');
                this.modal.classList.remove('no-stores');
                this.modal.classList.remove('error');

                try {
                    await Promise.all([
                        this.fetchStores(),
                        this.fetchStoreAvailability()
                    ]);

                    this.displayStoreAvailability();
                } catch (error) {
                    console.error('error fetching store availability:', error);
                    this.modal.classList.add('error');
                } finally {
                    this.modal.classList.remove('loading');
                }
            }

            async onAddressInputButtonClick(event) {
                event.preventDefault();

                if(this.addressInput.value.trim() !== '') {
                    this.updateBasedOnLocationChange();
                }
            }

            async onAddressKeyPress(event) {
                if (event.key === 'Enter') {
                    event.preventDefault();

                    if(this.addressInput.value.trim() !== '') {
                        this.updateBasedOnLocationChange();
                    }
                }
            }

            async updateBasedOnLocationChange() {
                this.location = this.addressInput.value.trim().toLowerCase();

                this.modal.classList.add('loading');
                this.modal.classList.remove('no-stores');
                this.modal.classList.remove('error');

                try {
                    const storesElement = this.modal.querySelector('#availability-in-stores-modal__stores');
                    storesElement.innerHTML = '';

                    await Promise.all([
                        this.fetchStoreAvailability()
                    ]);

                    this.displayStoreAvailability();
                } catch (error) {
                    console.error('error fetching store availability:', error);
                    this.modal.classList.add('error');
                } finally {
                    this.modal.classList.remove('loading');
                }
            }

            async fetchStores() {
                const response = await fetch(`${this.apiEndpoint}/address_panda`);
                this.stores = (await response.json()).filter(store => store.shop_id > 200);

                console.log(this.stores);
            }

            async fetchStoreAvailability() {
                const response = await fetch(`${this.apiEndpoint}/inventory?style=${this.currentProductStyle}&size=${this.currentProductSize}&place=${this.location}`);
                this.storeInventories = (await response.json()).sort((a, b) => a.distance - b.distance);
            }

            resetModal() {
                this.location = this.defaultLocation;
                this.addressInput.value = this.defaultLocation;
                
                const storesElement = this.modal.querySelector('#availability-in-stores-modal__stores');
                
                if(storesElement) {
                    storesElement.innerHTML = '';
                }

                this.modal.classList.remove('no-stores');
                this.modal.classList.remove('error');
            }

            displayStoreAvailability() {
                if(this.storeInventories.length === 0) {
                    this.modal.classList.add('no-stores');
                    return;
                }

                this.modal.classList.remove('no-stores');
                this.modal.classList.remove('error');

                const storesElement = this.modal.querySelector('#availability-in-stores-modal__stores');

                const ulElement = document.createElement('ul');
                ulElement.classList.add('availability-in-stores-modal__stores-list');
                
                this.storeInventories.forEach(storeInventory => {
                    const store = this.stores.find(s => s.shop_id === storeInventory.shop_id);

                    if(!store) {
                        return;
                    }

                    const storeElement = document.createElement('li');
                    storeElement.classList.add('availability-in-stores-modal__store');

                    const phone = this.formatPhone(store.phone || '');
                    let address = '';
                    if(store.location && store.location.address) {
                        address = store.location.address.full;
                    }
                    
                    storeElement.innerHTML = `
                        <h4 class="availability-in-stores-modal__store-name">${this.extractStoreName(store)}</h4>
                        <span class="availability-in-stores-modal__store-address">${address}</span>
                        <span class="availability-in-stores-modal__store-phone">${phone}</span>
                        <span class="availability-in-stores-modal__store-quantity">${this.prettyPrintQuantity(storeInventory.qty ?? 0)}</span>
                    `;
                    
                    ulElement.appendChild(storeElement);
                });
                
                storesElement.innerHTML = '';
                storesElement.appendChild(ulElement);
            }

            extractStoreName(store) {
                if (!store?.name) return '';
                
                if (store.name.includes('(')) {
                    return store.name.split('(')[1]?.replace(')', '') || '';
                } else {
                    return store.short_name || '';
                }
            }

            prettyPrintQuantity(quantity) {
                if (quantity === 1) {
                    return 'Il n\'en reste qu\'un seul!';
                }

                if (quantity > 1) {
                    return `Il n\'en reste que ${quantity}!`;
                }

                return 'Appelez en magasin pour vérifier l\'inventaire';
            }


            formatPhone(phone) {
                if (!phone || phone === '') {
                    return '';
                }

                return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            }

            closeModal() {
                this.modalWrapper.classList.remove('active');

                if (this.originalParent) {
                    this.originalParent.appendChild(this.modalWrapper);
                }

                document.body.classList.remove('availability-in-stores-modal-open');
            }

            onClickOutside(event) {
                console.log('onClickOutside', event.target);
                if (this.modalWrapper && !this.modal.contains(event.target) && event.target !== this.button) {
                    this.closeModal();
                }
            }
        }
    );
}

document.addEventListener('variant:changed', function(event) {
    const variant = event?.detail?.variant;
    if (!variant) return;
    
    const availabilityComponents = document.querySelectorAll('.js-availability-in-stores');
    if (!availabilityComponents?.length) return;

    availabilityComponents.forEach(component => {
        component?.setAttribute('data-variant-id', variant.id || '');
        component?.setAttribute('data-variant-sku', variant.sku || '');
        component?.setAttribute('data-product-size', variant.option2 || '');
    });
});